import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Checkbox, Form, Input, Select, Tooltip } from "antd";
import { FormServiceFieldTechnicalDefinitionsLayout } from "../table";
import { useI18n } from "../../../../../../../contexts";
const FormServiceFieldTechnicalDefinitionsCookieDuration = (param)=>{
    let { field, readOnly } = param;
    const { __ } = useI18n();
    const durations = useMemo(()=>({
            s: __("second(s)"),
            m: __("minute(s)"),
            h: __("hour(s)"),
            d: __("day(s)"),
            mo: __("month(s)"),
            y: __("year(s)")
        }), [
        __
    ]);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>{
            var _prevValues_technicalDefinitions_field_name, _nextValues_technicalDefinitions_field_name, _prevValues_technicalDefinitions_field_name1, _nextValues_technicalDefinitions_field_name1;
            return ((_prevValues_technicalDefinitions_field_name = prevValues.technicalDefinitions[field.name]) == null ? void 0 : _prevValues_technicalDefinitions_field_name.type) !== ((_nextValues_technicalDefinitions_field_name = nextValues.technicalDefinitions[field.name]) == null ? void 0 : _nextValues_technicalDefinitions_field_name.type) || ((_prevValues_technicalDefinitions_field_name1 = prevValues.technicalDefinitions[field.name]) == null ? void 0 : _prevValues_technicalDefinitions_field_name1.isSessionDuration) !== ((_nextValues_technicalDefinitions_field_name1 = nextValues.technicalDefinitions[field.name]) == null ? void 0 : _nextValues_technicalDefinitions_field_name1.isSessionDuration);
        },
        children: (param)=>{
            let { getFieldValue } = param;
            const type = getFieldValue([
                "technicalDefinitions",
                field.name,
                "type"
            ]);
            const isSessionDuration = getFieldValue([
                "technicalDefinitions",
                field.name,
                "isSessionDuration"
            ]);
            if ([
                "local",
                "session",
                "indexedDb",
                "flash"
            ].indexOf(type) > -1) {
                return null;
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: [
                            field.name,
                            "isSessionDuration"
                        ],
                        noStyle: true,
                        valuePropName: "checked",
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            style: {
                                float: "left",
                                marginTop: 5
                            },
                            disabled: readOnly,
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: __("This cookie is active as long as the session is active"),
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: __("Session")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        ...FormServiceFieldTechnicalDefinitionsLayout,
                        name: [
                            field.name,
                            "duration"
                        ],
                        rules: [
                            {
                                required: !isSessionDuration,
                                message: __("Please provide a valid duration!")
                            }
                        ],
                        dependencies: [
                            [
                                "technicalDefinitions",
                                field.name,
                                "isSessionDuration"
                            ]
                        ],
                        children: /*#__PURE__*/ _jsx(Input, {
                            disabled: readOnly,
                            min: "0",
                            addonAfter: /*#__PURE__*/ _jsx(Form.Item, {
                                name: [
                                    field.name,
                                    "durationUnit"
                                ],
                                noStyle: true,
                                rules: [
                                    {
                                        required: !isSessionDuration,
                                        message: __("Please provide an unit!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Select, {
                                    disabled: readOnly,
                                    children: Object.keys(durations).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                                            value: key,
                                            children: durations[key]
                                        }, key))
                                })
                            }),
                            type: "number",
                            style: {
                                maxWidth: 200,
                                display: isSessionDuration ? "none" : undefined
                            }
                        })
                    })
                ]
            });
        }
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieDuration };
